import { registerComponent } from 'lib/react_on_rails';

import { NewSessionPicker } from 'components/new_session_picker';
import { withPageProviders } from 'hoc/with_page_providers';
import { withReduxStore } from 'hoc/with_redux_store';

registerComponent(
  'NewSessionPicker',
  withPageProviders(withReduxStore(NewSessionPicker)),
);
